import('@syncfusion/ej2-base/styles/bootstrap5.3.css');
import('@syncfusion/ej2-layouts/styles/bootstrap5.3.css');

import('phuketfit-components/dist/phuketfit.css');

import * as PhuketFitReservationsApp from './reservationsApp';
(window as any).PhuketFitReservationsApp = PhuketFitReservationsApp;

import * as PhuketFitComponents from 'phuketfit-components';
(window as any).PhuketFitComponents = PhuketFitComponents;

import * as Components from './components/components';
(window as any).PhuketFitReservationsApp.Components = Components;

import * as Housekeeping from './housekeeping';
(window as any).PhuketFitReservationsApp.Housekeeping = Housekeeping;
Housekeeping.initialize();
